import { useEffect, useRef } from "react";
export function useLottie(config, autoPlaySegments) {
    const ref = useRef(null);
    useEffect(() => {
        if (!ref || !ref.current) {
            return;
        }
        // tslint:disable-next-line:no-typeof-undefined
        if (typeof lottie === "undefined") {
            return;
        }
        const animation = lottie.loadAnimation(Object.assign(Object.assign({ renderer: "svg", loop: true, autoplay: true }, config), { container: ref.current }));
        if (autoPlaySegments) {
            animation.playSegments(autoPlaySegments, true);
        }
    }, [ref]);
    return ref;
}
//# sourceMappingURL=useLottie.js.map